import { Box, Container, Heading, Image, Text } from '@redriverpress/system'
import { renderInlineMarkdown } from 'Common/utils/markdown'
import getInitialState from 'Common/utils/getInitialState'

import CollectionAndSublistTagsAlert from './CollectionAndSublistTags/CollectionAndSublistTagsAlert'

export default function CollectionHeader() {
  const {
    title,
    subtitle,
    description,
    banner,
    tag,
    userIsElliiAdmin,
  } = getInitialState()

  return (
    <Container as='header' pb={4}>
      {banner && <Image src={banner} mb={4} borderRadius='rounded' alt='' />}
      <Heading mb={3}>{title}</Heading>
      {subtitle && (
        <Heading as='h3' mb={3}>
          {subtitle}
        </Heading>
      )}
      {description && (
        <Text
          dangerouslySetInnerHTML={{
            __html: renderInlineMarkdown(description),
          }}
          measure
        />
      )}
      {/* Visible by ESL Library admins only */}
      {userIsElliiAdmin && (
        <Box display='inline-block'>
          <CollectionAndSublistTagsAlert tags={tag} title='Collection Tags' />
        </Box>
      )}
    </Container>
  )
}
